import { render, staticRenderFns } from "./MinisiteTransferConfirmation.vue?vue&type=template&id=23a91bd6&scoped=true&"
import script from "./MinisiteTransferConfirmation.vue?vue&type=script&lang=js&"
export * from "./MinisiteTransferConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteTransferConfirmation.vue?vue&type=style&index=0&id=23a91bd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a91bd6",
  null
  
)

export default component.exports